import type { GameManual } from '../types';
import { spiritIslandManual } from './spirit-island';
import { projektGajaManual } from './projekt-gaja';
import { weatherMachineManual } from './weather-machine';
import { voidfallManual } from './voidfall';
import { diunaImperiumManual } from './diuna-imperium';
import { nieswiadomyUmyslManual } from './nieswiadomy-umysl';

/**
 * Static, source-faithful manuals generated from local PEŁNA_INSTRUKCJA files.
 * Individual catalogues are intentionally kept partial until verified from the
 * physical components; no runtime filesystem access is used by the app.
 */
export const verifiedRulebooks: Record<string, GameManual> = {
  'spirit-island': spiritIslandManual,
  'projekt-gaja': projektGajaManual,
  'weather-machine': weatherMachineManual,
  voidfall: voidfallManual,
  'diuna-imperium': diunaImperiumManual,
  'nieswiadomy-umysl': nieswiadomyUmyslManual,
};

export function getVerifiedRulebook(gameId: string): GameManual | undefined {
  return verifiedRulebooks[gameId];
}
